import { GetServerSideProps } from 'next';
import { gsspWithNonce } from '@next-safe/middleware/dist/document';
import { BlogPostsPage } from '../../src/containers/blog/BlogPostsPage';
import { blogGetServerSideProps } from '../../src/containers/blog/blogGetServerSideProps';

// eslint-disable-next-line import/no-default-export
export default BlogPostsPage;

export const getServerSideProps: GetServerSideProps<BlogPostsPage> = gsspWithNonce(blogGetServerSideProps);
